import React, { useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'

import Colors from 'utils/Colors'
import { Help } from '@mui/icons-material'
import { Modal } from 'components'
import Button from '@mui/material/Button'
import HelpDialog from 'components/ManualAnalysisList/HelpDialog'
import styles from '../styles'

const ApplicationHelpButton = ({ useTitle = false }) => {
  const [openModal, setOpenModal] = useState(false)


  const classes = styles()

  const renderIconButton = () => (
    <IconButton onClick={() => setOpenModal(true)} size="large">
      <Help
        style={{
          color: Colors.primaryColor,
          fontSize: 20,
        }}
      />
    </IconButton>
  )

  const renderLabeledButton = () => (
    <Button
      size="small"
      variant="outlined"
      onClick={() => setOpenModal(true)}
      startIcon={
        <Help
          style={{
            color: Colors.primaryColor,
            fontSize: 20,
          }}
        />
      }
    >
      Ajuda
    </Button>
  )

  return (
    <React.Fragment>
      <Tooltip arrow placement="top" title={<b className={classes.tooltipText}>Abrir ajuda</b>}>
        {useTitle ? renderLabeledButton() : renderIconButton()}
      </Tooltip>
      <Modal open={openModal} onClose={() => setOpenModal(false)} title="Ajuda">
        <HelpDialog />
      </Modal>
    </React.Fragment>
  )
}

export default ApplicationHelpButton
